export default __webpack_public_path__ + "images/Upload_Icon.svg";